<main>
  <nav class="navbar navbar-expand-lg">
    <div class="container">
      <a class="navbar-brand me-lg-5 me-0" href="">
        <img src="assets/img/{{env.host.name}}/logo.png" class="logo-image img-fluid">
      </a>

      <button class="btn custom-btn custom-border-btn d-sm-none d-block" (click)="openModal(login)">
        Login
      </button>
      <button *ngIf="env.host.signUpActive" class="btn custom-btn custom-border-btn d-sm-none d-block" (click)="openSignUpModal()">
        Sign Up
      </button>

      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-lg-auto">
          <li class="nav-item">
            <a class="nav-link active" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/guest/dashboard']">Home</a>
          </li>
      
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', 4] : ['/guest/sports', 4]">Cricket</a>
          </li>
      
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', 1] : ['/guest/sports', 1]">football</a>
          </li>
      
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', 2] : ['/guest/sports', 2]">tennis</a>
          </li>
      
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', 99999] : ['/guest/sports', 99999]">casino</a>
          </li>
      
        </ul>
      
        <div class="ms-4">
          <a href="javascript:void(0);" class="btn custom-btn custom-border-btn" (click)="openModal(login)">Login</a>
        </div>
        <div class="ms-4">
          <a href="javascript:void(0);" class="btn custom-btn custom-border-btn" (click)="openSignUpModal()">Sign Up</a>
        </div>
      </div>
    </div>
  </nav>

  <section class="hero-section">
    <div class="container">
      <div class="row">

        <div class="col-lg-12 col-12">
          <div class="text-center mb-5 pb-2">
            <h1 class="text-white">Betting with {{env.host.name}}</h1>

            <p class="text-white">Every odds of fancy and other market in advance level.</p>

            <a href="javascript:void(0)" (click)="openModal(login)" class="btn custom-btn mt-3">Start betting</a>
          </div>

          <div class="owl-carousel owl-theme">
            <div class="owl-carousel-info-wrap item" [routerLink]="_common.getToken() ? ['/sports', 4] : ['/guest/sports', 4]">
              <img src="https://speedcdn.io/assets/king-v8/landing01/thumb-cricket.jpg" class="owl-carousel-image img-fluid" alt="">
              <div class="owl-carousel-info">
                <h4 class="mb-2">
                  cricket
                </h4>
                <span class="badge">in-play</span>
                <span class="badge">bookmaker</span>
              </div>
              <div class="social-share">
                <ul class="social-icon">
                  <li class="social-icon-item">
                    <a href="javascript:void(0)" class="social-icon-link">9</a>
                  </li>
                </ul>
              </div>
            </div>
          
            <div class="owl-carousel-info-wrap item" [routerLink]="_common.getToken() ? ['/sports', 1] : ['/guest/sports', 1]">
              <img src="https://speedcdn.io/assets/king-v8/landing01/thumb-football.jpg" class="owl-carousel-image img-fluid" alt="">
              <div class="owl-carousel-info">
                <h4 class="mb-2">
                  football
                </h4>
                <span class="badge">in-play</span>
                <span class="badge">bookmaker</span>
              </div>
              <div class="social-share">
                <ul class="social-icon">
                  <li class="social-icon-item">
                    <a href="javascript:void(0)" class="social-icon-link">9</a>
                  </li>
                </ul>
              </div>
            </div>
          
            <div class="owl-carousel-info-wrap item" [routerLink]="_common.getToken() ? ['/sports', 2] : ['/guest/sports', 2]">
              <img src="https://speedcdn.io/assets/king-v8/landing01/thumb-tennis.jpg" class="owl-carousel-image img-fluid" alt="">
              <div class="owl-carousel-info">
                <h4 class="mb-2">
                  tennis
                </h4>
                <span class="badge">in-play</span>
                <span class="badge">bookmaker</span>
              </div>
              <div class="social-share">
                <ul class="social-icon">
                  <li class="social-icon-item">
                    <a href="javascript:void(0)" class="social-icon-link">9</a>
                  </li>
                </ul>
              </div>
            </div>
          
            <div class="owl-carousel-info-wrap item" [routerLink]="_common.getToken() ? ['/sports', 7] : ['/guest/sports', 7]">
              <img src="https://speedcdn.io/assets/king-v8/landing01/thumb-horse.jpg" class="owl-carousel-image img-fluid" alt="">
              <div class="owl-carousel-info">
                <h4 class="mb-2">
                  horse racing
                </h4>
                <span class="badge">in-play</span>
                <span class="badge">bookmaker</span>
              </div>
              <div class="social-share">
                <ul class="social-icon">
                  <li class="social-icon-item">
                    <a href="javascript:void(0)" class="social-icon-link">9</a>
                  </li>
                </ul>
              </div>
            </div>
          
          </div>
        </div>

      </div>
    </div>
  </section>


  <section class="casino-section section-padding pb-0">
    <div class="container">
      <div class="row">
  
        <div class="col-lg-12 col-12">
          <div class="section-title-wrap">
            <h4 class="section-title">Trending Casino</h4>
          </div>
        </div>
  
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/98795.png" class="img-fluid" alt="">
            </a>
            <h5>Amar Akbar Anthony</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/98792.png" class="img-fluid" alt="">
            </a>
            <h5>Roulette Virtual</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/67720.png" class="img-fluid" alt="">
            </a>
            <h5>Super Over</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/67630.png" class="img-fluid" alt="">
            </a>
            <h5>Teenpatti Test</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/67600.png" class="img-fluid" alt="">
            </a>
            <h5>Mulfis Teenpatti</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/92037.png" class="img-fluid" alt="">
            </a>
            <h5>Matka</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/90100.png" class="img-fluid" alt="">
            </a>
            <h5>Race 20-20</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-6">
          <div class="custom-block">
            <a href="javascript:void(0)" (click)="openModal(login)">
              <img src="https://speedcdn.io/assets/casino-old/87564.png" class="img-fluid" alt="">
            </a>
            <h5>Andar Bahar</h5>
          </div>
        </div>
  
      </div>
    </div>
  </section>
  
  <section class="our-casino-poster section-padding">
    <div class="container">
      <div class="row">
  
        <div class="col-lg-12 col-12">
          <div class="section-title-wrap">
            <h4 class="section-title">our casino</h4>
          </div>
        </div>
    
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/56766.png" class="img-fluid" alt="">
          </a>
        </div>
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/67570.png" class="img-fluid" alt="">
          </a>
        </div>
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/56768.png" class="img-fluid" alt="">
          </a>
        </div>
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/67690.png" class="img-fluid" alt="">
          </a>
        </div>
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/56966.png" class="img-fluid" alt="">
          </a>
        </div>
        <div class="col-lg-4 col-6">
          <a href="javascript:void(0)" (click)="openModal(login)">
            <img src="https://speedcdn.io/assets/casino-old/56968.png" class="img-fluid" alt="">
          </a>
        </div>
    
      </div>
    </div>
  </section>

  <section class="our-providers section-padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="section-title-wrap">
            <h4 class="section-title">our providers</h4>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="owl-carousel owl-theme">
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr1.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr2.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr3.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr4.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr5.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr6.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr7.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr8.svg" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr9.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr10.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr11.png" class="owl-carousel-image img-fluid" alt="">
            </div>
            <div class="owl-carousel-info-wrap item">
              <img src="https://speedcdn.io/assets/king-v8/landing01/pvr12.png" class="owl-carousel-image img-fluid" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<footer class="site-footer">
  <div class="container">
    <div class="row">

      <div class="col-lg-4 col-12">
        <a href="">
          <img src="assets/img/{{env.host.name}}/logo.png" class="footer-logo img-fluid" alt="">
        </a>
        <p>Our website works best in the newest and last prior version of these browsers: Google Chrome. Firefox</p>
      </div>

      <div class="col-lg-4 col-12">
        <ul class="site-footer-links">
          <li class="site-footer-link-item">
            <a href="javascript:void(0)" class="site-footer-link" data-bs-toggle="modal" data-bs-target="#pp">Privacy Policy</a>
          </li>

          <li class="site-footer-link-item">
            <a href="javascript:void(0)" class="site-footer-link" data-bs-toggle="modal" data-bs-target="#tac">Terms And Conditions</a>
          </li>

          <li class="site-footer-link-item">
            <a href="javascript:void(0)" class="site-footer-link" data-bs-toggle="modal" data-bs-target="#rar">Rules And Regulations</a>
          </li>
        </ul>
      </div>


      <div class="col-lg-4 col-12">
        <ul class="site-footer-links">

          <li class="site-footer-link-item">
            <a href="javascript:void(0)" class="site-footer-link" data-bs-toggle="modal" data-bs-target="#ab">About Us</a>
          </li>

          <li class="site-footer-link-item">
            <a href="javascript:void(0)" class="site-footer-link" data-bs-toggle="modal" data-bs-target="#rg">Responsible Gaming</a>
          </li>
        </ul>

        <p class="copyright-text mb-0">
          Copyright © 2023 {{env.host.name}}
        </p>
      </div>

    </div>


    <div class="row">
      <div class="col-12">
        <div class="footer-bottom">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-01.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-02.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-03.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-04.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-05.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-06.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-07.png">
          <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing01/img-08.png">
        </div>
      </div>
    </div>

  </div>
</footer>


<!-- pp -->
<div class="modal fade login-popup-ui" id="pp" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalLabel"
  aria-bs-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="logindiv">
          <p>content here</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--pp-->

<!-- rar -->
<div class="modal fade login-popup-ui" id="rar" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalLabel"
  aria-bs-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="logindiv">
          <p>content here</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--rar-->

<!-- ab -->
<div class="modal fade login-popup-ui" id="ab" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalLabel"
  aria-bs-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="logindiv">
          <p>content here</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--ab-->

<!-- tac -->
<div class="modal fade login-popup-ui" id="tac" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalLabel"
  aria-bs-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="logindiv">
          <p>content here</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--tac-->

<!-- Responsible Gaming -->
<div class="modal fade login-popup-ui" id="rg" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalLabel"
  aria-bs-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="logindiv">
          <p>content here</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Responsible Gaming -->


<ng-template #login>
  <div class="modal-body">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
    <!-- <h2>Welcome to {{env.host.domain}} <small>{{env.host.ext}}</small></h2> -->
    <app-login-page (closeLogin)="closeModel()" (forceChangePwd)="openAppMoadal(changePwd)"></app-login-page>
  </div>
</ng-template>

<ng-template #changePwd>
  <div class="modal-body">

    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
    <h2 id="">Change Password</h2>
    <app-change-password class="modal-change-pwd" (openLogin)="openAppMoadal(login)"
      [isModal]="true"></app-change-password>
    <!-- <app-login (forceChangePwd)="forceChangePwd()"></app-login> -->
  </div>
</ng-template>